import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminAssetsCatalogKey } from './assets.i18n.js';
import { ADMIN_ASSETS_CATALOG } from './assets.i18n.js';

export type AdminAssetsMessageId = `adminAssets:${AdminAssetsCatalogKey}`;

const PREFIX_LENGTH = 'adminAssets:'.length;

/** `t()` for the stop-gap `adminAssets:` scope (see `assets.i18n.ts`). */
export function useAssetsT(): { t: (id: AdminAssetsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminAssetsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminAssetsCatalogKey;
      const raw = ADMIN_ASSETS_CATALOG[locale][key] ?? ADMIN_ASSETS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
